export enum DealStructureEnum {
  SHARES_DEAL = 'SharesDeal',
  ASSET_DEAL = 'AssetDeal',
}
